var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 63,
    viewBox: "0 0 51 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5548_44250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.817338,
    y: 0.425018,
    width: 28.9544,
    height: 40.8695,
    rx: 6.50406,
    transform: "matrix(0.954049 -0.29965 0.302608 0.953115 3.90894 13.3308)",
    fill: "#012B4B",
    stroke: "#7CFFEB",
    strokeWidth: 1.30081
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5175 23.4433C22.5228 22.8147 23.3301 22.5611 23.6973 23.0727L25.4534 25.5191C25.6177 25.748 25.9105 25.8458 26.1791 25.7614L29.0551 24.8581C29.6569 24.6691 30.1508 25.3606 29.7751 25.8661L27.9858 28.2734C27.8174 28.4998 27.8152 28.8093 27.9801 29.039L29.7312 31.4786C30.0988 31.9907 29.5967 32.6716 28.9982 32.4727L26.1304 31.5197C25.8636 31.431 25.5703 31.5231 25.403 31.7481L23.6056 34.1664C23.2304 34.6711 22.4262 34.4005 22.4315 33.7713L22.4564 30.7739C22.4588 30.4916 22.2783 30.2396 22.0097 30.1504L19.1549 29.2017C18.5554 29.0025 18.5605 28.1543 19.1623 27.9653L22.0383 27.062C22.3069 26.9776 22.4901 26.7303 22.4925 26.4491L22.5175 23.4433Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0039,
    y: 16.4846,
    width: 28.9691,
    height: 40.8488,
    rx: 6.50406,
    fill: "#012B4B",
    stroke: "#7CFFEB",
    strokeWidth: 1.30081
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5548_44250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8701 31.2748C30.0655 30.6769 30.9113 30.6769 31.1066 31.2748L32.0409 34.1347C32.1283 34.4021 32.3778 34.5831 32.6591 34.5831H35.675C36.3059 34.5831 36.5673 35.3911 36.0559 35.7607L33.6221 37.5194C33.3929 37.685 33.297 37.9797 33.3848 38.2485L34.3159 41.0986C34.5114 41.6972 33.8271 42.1966 33.3167 41.8277L30.8693 40.0592C30.6419 39.8949 30.3348 39.8949 30.1074 40.0592L27.6601 41.8277C27.1497 42.1966 26.4653 41.6972 26.6609 41.0986L27.5919 38.2485C27.6798 37.9797 27.5838 37.685 27.3546 37.5194L24.9208 35.7607C24.4095 35.3911 24.6709 34.5831 25.3018 34.5831H28.3176C28.599 34.5831 28.8485 34.4021 28.9359 34.1347L29.8701 31.2748Z",
    fill: "#FBFD00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5548_44250",
    x: 0.928125,
    y: 0.912866,
    width: 49.5954,
    height: 61.9709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5548_44250"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5548_44250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5548_44250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5548_44250",
    x: 21.6504,
    y: 28.8264,
    width: 17.6763,
    height: 17.1276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5548_44250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5548_44250",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlus);
export default __webpack_public_path__ + "static/media/card-plus.440fc80cb3d53eff2d62a75e88c9cc42.svg";
export { ForwardRef as ReactComponent };